import(/* webpackMode: "eager", webpackExports: ["ReeferAFriend"] */ "/home/runner/work/monorepo/monorepo/packages/tokers-web/src/app/reefer/[code]/_components/ReeferAFriend.tsx");
